/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import Graphql from '@/services/Graphql'
import { minMaxFromPriceArr } from '@/helpers/utils'
import Logger from '@/services/Logger'
import each from 'lodash/each'

export default {
  filterProducts (ctx, { categoryId, q }) {
    let searchGraph = {
      filter: {},
      currentPage: Math.ceil(ctx.state.pagination.start / ctx.state.pagination.size) + 1,
      pageSize: ctx.state.pagination.size
    }

    if (categoryId) {
      let currentCat = ctx.rootState.category.flatted.find(cat => cat.id === categoryId)

      searchGraph.filter.category_id = {
        'in': ['' + categoryId].concat(currentCat.childrenAllIds.split(','))
      }
      searchGraph.id = parseInt(categoryId)
    } else {
      if (q !== undefined) {
        searchGraph.search = q
      }
    }

    // sort order
    searchGraph.sort = {
      [ctx.state.sort]: ctx.state.sortOrientation
    }

    each(ctx.state.filters.chosen, (value, key) => {
      if (value && value.length) {
        if (key === 'price') {
          let priceMinMax = minMaxFromPriceArr(value)
          priceMinMax.from = '' + priceMinMax.from
          priceMinMax.to = '' + priceMinMax.to
          searchGraph.filter[key] = priceMinMax
        } else {
          searchGraph.filter[key] = { in: value.join(',') }
        }
      }
    })

    return Graphql.genericCallCash({
      token: ctx.rootState.user.token, // token
      storeViewCode: ctx.rootState.ui.storeViewCode, // storeViewCode
      graphSchemaType: 'graphListing',
      variables: searchGraph // variable
    })
      .then(res => {
        if (res.errors) {
          Logger.error('listing call error: ', res)
          ctx.dispatch('resetListing')
          return false
        }
        const listing = res.data
        // create flatted categories
        if (listing && listing.products) {
          ctx.commit('setProducts', listing.products.items)
          ctx.commit('setPagination', { ...ctx.state.pagination, total: listing.products.total_count })
          ctx.commit('setAvailableFilters', { filters: listing.products.aggregations.filter(agg => agg.attribute_code !== 'category_id') })
          ctx.commit('setSortable', listing.products.sort_fields.options)
        }
        if (listing && listing.category) {
          ctx.commit('category/setMetaData', listing.category, { root: true })
        }
        return listing
      })
  },
  resetListing (ctx) {
    ctx.commit('setProducts', [])
    ctx.commit('setPagination', { ...ctx.state.pagination, total: 0, start: 0 })
  },
  manageQuickView (ctx, product) {
    let quickBool = Object.keys(product).length > 0
    ctx.commit('listing/setQuickView', quickBool, { root: true })
    ctx.commit('product/setCurrent', product, { root: true })
  },
  updateListingByIndex (ctx, { newProduct, listIndex }) {
    let listingArray = ctx.state.list
    return ctx.dispatch('product/loadByUrlKey', newProduct.url_key + newProduct.url_suffix, { root: true })
      .then(product => {
        let mapArr = listingArray.map((item, index) => {
          if (index === listIndex) {
            return product
          }
          return item
        })
        ctx.commit('setProducts', mapArr)
      })
  }
}
